import React from 'react';

const Score = ( {problemNumber, problemsCorrect}) => {

    const problemsTried = problemNumber-1;
    const percentage = (isNaN(problemsCorrect/problemsTried)) ? "" : ` (${Math.round(100*problemsCorrect/problemsTried)}%)`;

    return(
        <div className="score">
            <h3>
                Score:
            </h3>
            <div className="score-message">
                <span>{problemsCorrect}</span> {(problemsCorrect!==1) ? "problems" : "problem"} correct out of <span>{problemsTried}</span> tried. 
                {percentage}
            </div>
        </div>
    );

};

export default Score;